/**
 * 261030 S10 (M5/H5) — hai tiện ích để KHÔNG BAO GIỜ nuốt lỗi im lặng ở luồng 4 bước (inv-113: «chặn giữa chừng mà chả thấy lỗi gì»).
 * `noteSwallowed`: nơi buộc phải bỏ qua một lỗi (best-effort: tên plan, bộ nhớ trình duyệt…) thì vẫn ghi dấu ra console kèm «ở đâu» — test AST (`fourNoSilentCatch.source.test.ts`) cấm `catch {}` rỗng / `.catch(() => undefined)` trong `source-stories/*Four*`.
 * `assertNever`: switch vét cạn — thêm một giá trị union mà quên nhánh thì tsc báo lỗi ngay.
 * Không import React/antd để jest chạy được.
 */
export function noteSwallowed(where: string, err?: unknown): void {
  // eslint-disable-next-line no-console
  console.warn(`[workflowFour] bỏ qua lỗi ở ${where}`, err);
}
/** `.catch(onSwallow('tên việc'))` — thay `.catch(() => undefined)`. */
export const onSwallow = (where: string) => (err: unknown): undefined => { noteSwallowed(where, err); return undefined; };
export function assertNever(x: never, where = 'switch'): never {
  throw new Error(`workflowFour: nhánh chưa khai ở ${where}: ${String(x)}`);
}
/** `.catch(onSwallowNull('tên việc'))` — thay `.catch(() => null)` khi caller phân biệt «đọc được» / «không đọc được» bằng null. */
export const onSwallowNull = (where: string) => (err: unknown): null => { noteSwallowed(where, err); return null; };
